if (import.meta.hot) {
	import.meta.hot.accept();
}

import { loadApp, loadModule } from '@spon/core';
import 'lazysizes';

import Header from '@/globals/Header';

import SetVh from '@/globals/SetVh';
import FadeIn from '@/globals/FadeIn';

import '@/plugins/logger';
import webfontloader from '@/plugins/webfontloader';
import detectTab from '@/utils/detectTab';
import activeLinks from '@/utils/activeLinks';
import localLinks from '@/utils/localLinks';

webfontloader();

// load from data-behaviours
const app = loadApp(name => import(`./behaviours/${name}.js`), document.body); // eslint-disable-line

loadModule({
	module: Header,
	id: 'header',
	node: document.getElementById('header'),
	keepAlive: true,
});

loadModule({
	module: SetVh,
	id: 'set-vh',
	node: document.body,
	keepAlive: true,
});

loadModule({
	module: FadeIn,
	id: 'fadein',
	node: document.body,
	keepAlive: true,
});

detectTab();
activeLinks(window.location.pathname);
localLinks();

// https://htmx.org/events
if (typeof htmx !== 'undefined') {
	// Scroll to top of `sprig` container when interacting; but only when `scroll` is in Param (eg not filtering; but probably pagination)
	// eslint-disable-next-line
	htmx.on('htmx:beforeSwap', ({ target }) => {
		localLinks(target);
	});

	// Used if sprig target != results; dont' rely on DOM change to remove `.is-loading`
	htmx.on(
		'htmx:afterSwap',
		({
			target,
			detail: {
				requestConfig: { triggeringEvent },
			},
		}) => {
			loadApp(name => import(`./behaviours/${name}.js`), target); // eslint-disable-line

			if (triggeringEvent) {
				const { srcElement } = triggeringEvent;
				if (!srcElement) return;

				const shouldScroll = srcElement.closest('[data-pagination]');
				if (srcElement && shouldScroll) {
					window.scroll(
						0,
						target.getBoundingClientRect().top + window.scrollY - 100
					);
				}
			}
		}
	);
}
